import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import FadeIn from '../../components/base/FadeIn';
import hakkimizdaHero from '../../assets/images/hero-hakkimizda.jpg';
import { WHATSAPP_CHAT_URL } from '../../config/contactLinks';
import aboutStaffImage from '../../assets/images/about-staff.jpg';

const stats = [
  { value: '500+', label: 'Tamamlanan Proje', icon: 'ri-check-double-line' },
  { value: '5+', label: 'Yıllık Deneyim', icon: 'ri-calendar-check-line' },
  { value: '11', label: 'Hizmet Çeşidi', icon: 'ri-service-line' },
  { value: '%100', label: 'Memnuniyet', icon: 'ri-emotion-happy-line' },
];

const features = [
  { icon: 'ri-shield-check-line', title: 'Sigortalı Ekip', desc: 'Tüm personelimiz sigortalı ve güvenlik kontrolünden geçmiş.' },
  { icon: 'ri-leaf-line', title: 'Çevre Dostu', desc: 'Sertifikalı, doğa ve insan sağlığına uygun ürünler kullanıyoruz.' },
  { icon: 'ri-time-line', title: 'Zamanında Hizmet', desc: 'Belirtilen saat ve günde, hiç geç kalmadan hizmet sunuyoruz.' },
  { icon: 'ri-tools-line', title: 'Profesyonel Ekipman', desc: 'Endüstriyel makineler ile üstün temizlik kalitesi sağlıyoruz.' },
  { icon: 'ri-award-line', title: 'Kalite Garantisi', desc: 'Her hizmet sonrası memnuniyet garantisi veriyoruz.' },
  { icon: 'ri-team-line', title: 'Deneyimli Kadro', desc: '5 yıl üzeri deneyimli, eğitimli profesyonel ekip.' },
];

const values = [
  { num: '01', title: 'Güven', desc: 'Evinize ya da işyerinize kişisel alanınızmış gibi saygıyla yaklaşıyoruz.' },
  { num: '02', title: 'Kalite', desc: 'Her hizmette yüksek standartları korumak önceliğimizdir.' },
  { num: '03', title: 'Şeffaflık', desc: 'Net fiyatlandırma, gizli ücret yok, net iletişim.' },
];

export default function HakkimizdaPage() {
  return (
    <PageLayout>
      <PageHero
        label="Biz Kimiz?"
        title="NiğPak Temizlik"
        subtitle="Niğde'nin güvenilir profesyonel temizlik firması. 5 yılı aşkın deneyim, 500+ memnun müşteri."
        bgImage={hakkimizdaHero}
      />

      {/* Story section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row gap-16 items-center">

            {/* Image */}
            <FadeIn direction="right" className="w-full lg:w-[46%] shrink-0">
              <div className="relative">
                <div className="absolute top-6 left-6 right-0 bottom-0 bg-navy/5 rounded-2xl -z-0" />
                <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
                  <img
                    src={aboutStaffImage}
                    alt="NiğPak Temizlik ekibi"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-navy/20 to-transparent" />
                </div>
                <div className="absolute -bottom-3 -right-3 w-24 h-24 border-4 border-gold rounded-xl -z-0" />
                <div className="absolute -bottom-5 left-8 bg-navy text-white rounded-xl px-5 py-4 z-10">
                  <div className="flex items-end gap-1">
                    <span className="text-3xl font-extrabold text-gold leading-none">10</span>
                    <span className="text-gold font-extrabold text-lg leading-snug">+</span>
                  </div>
                  <div className="text-[10px] font-bold mt-1 text-white/60 uppercase tracking-wider">Yıllık Deneyim</div>
                </div>
                <div className="absolute top-5 -right-4 bg-white rounded-xl px-4 py-3 z-10"
                  style={{ boxShadow: '0 4px 20px rgba(26,43,94,0.12)' }}>
                  <div className="flex items-center gap-1 mb-1">
                    {[1,2,3,4,5].map(i => (
                      <span key={i} className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-gold text-xs"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-navy font-extrabold text-xs">500+ Yorum</p>
                  <p className="text-gray-400 text-[10px]">Memnun Müşteri</p>
                </div>
              </div>
            </FadeIn>

            {/* Text */}
            <FadeIn direction="left" className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-[2px] bg-gold rounded-full" />
                <p className="text-gold text-[11px] font-bold uppercase tracking-[0.25em]">Hikayemiz</p>
              </div>
              <h2 className="text-4xl md:text-5xl font-extrabold text-navy tracking-tight leading-tight mb-6">
                5 Yılda<br />Niğde&apos;nin Tercih Ettiği<br />Temizlik Markası
              </h2>
              <p className="text-gray-500 text-sm leading-[1.9] mb-5">
                <strong className="text-navy font-semibold">NiğPak Temizlik</strong>, Niğde Merkez&apos;de kurulmuş, 5 yılı aşkın deneyimiyle bölgenin en güvenilir profesyonel temizlik firmasıdır. Kuruluşumuzdan bu yana müşterilerimize mükemmel hizmet sunmak için titizlikle çalışıyoruz.
              </p>
              <p className="text-gray-500 text-sm leading-[1.9] mb-8">
                Daire temizliğinden villa temizliğine, inşaat sonrasından kurumsal mağazaya kadar 11 farklı temizlik hizmetiyle Niğde&apos;deki her ihtiyacınıza çözüm üretiyoruz. Deneyimli ekibimiz, sertifikalı ürünlerimiz ve profesyonel ekipmanlarımızla fark yaratıyoruz.
              </p>

              {/* Values */}
              <div className="flex flex-col gap-4">
                {values.map(v => (
                  <div key={v.num} className="flex items-start gap-4">
                    <span className="text-[11px] font-extrabold text-gold tracking-wider shrink-0 mt-0.5">{v.num}</span>
                    <div className="flex-1 border-b border-gray-100 pb-4">
                      <p className="text-navy font-bold text-sm mb-1">{v.title}</p>
                      <p className="text-gray-400 text-xs leading-relaxed">{v.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 bg-navy hover:bg-gold text-white font-bold px-6 py-3.5 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer mt-8">
                <i className="ri-whatsapp-line text-base"></i>
                Ücretsiz Teklif Al
              </a>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-4 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <FadeIn>
            <div className="relative rounded-2xl overflow-hidden bg-navy">
              <div className="absolute inset-0 opacity-5"
                style={{ backgroundImage: 'radial-gradient(circle, #c9a84c 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
              <div className="relative grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
                {stats.map(s => (
                  <div key={s.label} className="py-10 flex flex-col items-center gap-2 group px-4">
                    <span className="w-10 h-10 flex items-center justify-center bg-gold/15 rounded-xl mb-1 group-hover:bg-gold/25 transition-colors">
                      <i className={`${s.icon} text-gold text-lg`}></i>
                    </span>
                    <div className="text-4xl md:text-5xl font-extrabold text-white leading-none">{s.value}</div>
                    <div className="text-white/40 text-[11px] font-semibold uppercase tracking-[0.15em] text-center">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Features */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <FadeIn className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-gold rounded-full" />
              <p className="text-gold text-[11px] font-bold uppercase tracking-[0.25em]">Neden Biz?</p>
            </div>
            <h2 className="text-4xl font-extrabold text-navy tracking-tight">Farkımız</h2>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((f, i) => (
              <FadeIn key={f.title} delay={i * 0.08}>
                <div className="flex items-start gap-4 border border-gray-100 rounded-xl p-5 hover:border-gold/40 transition-colors h-full">
                  <span className="w-10 h-10 flex items-center justify-center bg-gold/10 rounded-xl shrink-0">
                    <i className={`${f.icon} text-gold text-lg`}></i>
                  </span>
                  <div>
                    <p className="text-navy font-bold text-sm mb-1">{f.title}</p>
                    <p className="text-gray-400 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
